import React from 'react'
import {
  SUPPORT_ICON,
  EXPRESSWAY_ICON,
  ACCOUNT_ICON_FILL_COLOR,
  ACCOUNT_ICON_SIZE,
} from 'AccountsConstants/app'
import Expressway from 'AccountsIcons/expressway.svg'
import Support from 'AccountsIcons/support.svg'

const AccountIcon = ({ icon }) => {
  let accountIcon = null
  if (icon === EXPRESSWAY_ICON) {
    accountIcon = (
      <Expressway
        fill={ACCOUNT_ICON_FILL_COLOR}
        width={ACCOUNT_ICON_SIZE}
        height={ACCOUNT_ICON_SIZE}
      />
    )
  } else if (icon === SUPPORT_ICON) {
    accountIcon = (
      <Support
        fill={ACCOUNT_ICON_FILL_COLOR}
        width={ACCOUNT_ICON_SIZE}
        height={ACCOUNT_ICON_SIZE}
      />
    )
  }
  return accountIcon
}

export default AccountIcon
